import React, { useState, useEffect } from "react";
import validator from "validator";
import axios from "axios";
import { useAuth } from "../contexts/auth";
import { postOrderCompleteURL } from "../utils/api";
import {
    Flex,
    Spacer,
    Button,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    FormControl,
    FormLabel,
    FormErrorMessage,
    FormHelperText,
    Input,
    Text,
    RadioGroup,
    Radio,
    HStack,
    Box,
    InputRightElement,
    useColorModeValue,
    Alert,
    AlertIcon,
    AlertTitle,
  } from "@chakra-ui/react";

function CompleteOrder({
    isOpen,
    onClose,
    successCallback,
    orderData,
}) {
    const textColor = useColorModeValue("gray.700", "white");   


    const { auth } = useAuth();
    const [ errors, setErrors ] = useState([]);
    const [ submitting, setSubmitting ] = useState(false);

    const postPayments = (e) => {
        e.preventDefault();

        let id;
        if (orderData) {
            id = orderData.id;
        }

        setSubmitting(true);
        // console.log(email, password);
        axios.post(postOrderCompleteURL(id), {
            // amount,
        },{
            headers: {
                Authorization: `Bearer ${auth.authToken}`
            }
        }).then(result => {
            if (result.status === 200) {
                // const roles = result.data.data.user.roles;
                const user = result.data.data;
                // console.log(user);
                if (successCallback) {
                    successCallback();
                }
                onClose();
            } else {
                setErrors(result.data.errors);
            }
        }).catch(e => {
            if (e.response === undefined) {
                setErrors(['Could not connect to server!'])
            } else {
                setErrors(e.response.data.errors)
            }
        }).finally(e => {
            setSubmitting(false);
        });
    }

    useEffect(() => {
        if (orderData) {
            let tmp = [];
            if (parseFloat(orderData.paymentsTotal) < parseFloat(orderData.total)) {
                tmp.push('Total is not yet achieved!');
            }
            setErrors(tmp);
        }
    }, [orderData]);


    if (orderData == null) {
        return (<></>);
    }

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
            <ModalHeader>Please Confirm</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
                <form onSubmit={postPayments}>
                    <FormControl >
                    <Flex direction="column">
                            <Flex align="center">
                                <Text
                                fontSize="md"
                                color={textColor}
                                fontWeight="bold"
                                me="10px"
                                >
                                Client:{" "}
                                </Text>
                                <Text fontSize="md" color="gray.500" fontWeight="400">
                                { orderData.customer.companyName 
                                    ? orderData.customer.companyName
                                    : `${orderData.customer.firstName} ${orderData.customer.lastName}`
                                }
                                </Text>
                            </Flex>
                            <Flex align="center">
                                <Text
                                fontSize="md"
                                color={textColor}
                                fontWeight="bold"
                                me="10px"
                                >
                                Mobile:{" "}
                                </Text>
                                <Text fontSize="md" color="gray.500" fontWeight="400">
                                { orderData.customer.companyNumber 
                                    ? orderData.customer.companyNumber
                                    : orderData.customer.mobile
                                }
                                </Text>
                            </Flex>
                            <Flex align="center">
                                <Text
                                fontSize="md"
                                color={textColor}
                                fontWeight="bold"
                                me="10px"
                                >
                                Vehicle:{" "}
                                </Text>
                                <Text fontSize="md" color="gray.500" fontWeight="400">
                                { orderData.carMake } { orderData.carType } { orderData.carYear } 
                                { orderData.carPlate } { orderData.carOdometer }
                                </Text>
                            </Flex>

                            <Flex align="center">
                                <Text
                                fontSize="md"
                                color={textColor}
                                fontWeight="bold"
                                me="10px"
                                >
                                Paid / Total:{" "}
                                </Text>
                                <Text fontSize="md" color="gray.500" fontWeight="400">
                                {parseFloat(orderData.paymentsTotal)}/{parseFloat(orderData.total)}
                                </Text>
                            </Flex>
                       
                        </Flex>

                        <Alert><AlertIcon></AlertIcon><AlertTitle>Warning</AlertTitle>This action cannot be reversed!</Alert>
                        
                        <Flex w="100%" flexDir="column" mt="12px" mb="12px">
                            { errors.length > 0 && <Text color="red">{errors[0]}</Text> }
                        </Flex>
                        <Button
                            fontSize="10px"
                            type="submit"
                            bg="teal.300"
                            w="100%"
                            h="45"
                            mb="20px"
                            color="white"
                            mt="0px"
                            _hover={{
                            bg: "teal.200",
                            }}
                            _active={{
                            bg: "teal.400",
                            }}
                            isDisabled={submitting}
                        >
                            COMPLETE ORDER
                        </Button>
                    </FormControl>
                </form>
            </ModalBody>
            </ModalContent>
        </Modal>
    );

}



export default CompleteOrder;
